import React from 'react';
import styles from './Layout.module.scss';

export const Layout = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.layout}>{children}</div>;
};

export const Main = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return <main className={className}>{children}</main>;
};
